import React, { useState } from "react";
import Layout from "../Layout";
import List from "../Components/Raw Material/List";
import Add from "../Components/Raw Material/Add";

function RawMaterial() {
  const [comp, setComp] = useState("list");
  const [rowData, setRowData] = useState();

  function handleChange(newValue) {
    setComp(newValue.mode);
    setRowData(newValue.rowData);
  }

  return (
    <Layout>
      <div className="main-content">
        <section className="section">
          <div className="section-header">
            <h1>Raw Material</h1>
          </div>
          {comp === "list" ? (
            <List comp={comp} onChange={handleChange} rowData={rowData} />
          ) : (
            <Add comp={comp} rowData={rowData} onChange={handleChange} />
          )}
        </section>
      </div>
    </Layout>
  );
}

export default RawMaterial;
